import { getRideMetadataMappings } from '@engage/api-v2';
import { engageApi } from '../lib/singletons';
import { unwrap } from '../lib/unwrap';
import { toFetcher } from './toFetcher';
export var toMetadataFetchers = function toMetadataFetchers() {
  var api = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : engageApi;
  return {
    GetRideMetadataMappings: toFetcher(function (_req, _opt) {
      return 'GetRideMetadataMappings';
    }, function (_ref, _ref2) {
      var pelotonPlatform = _ref.pelotonPlatform;
      var acceptLanguage = _ref2.acceptLanguage;
      return unwrap(function () {
        return getRideMetadataMappings(api, pelotonPlatform, acceptLanguage !== null && acceptLanguage !== void 0 ? acceptLanguage : 'en-US');
      });
    }, {
      dedupingInterval: 60 * 1000 * 30 // 30 Minutes

    })
  };
};